import { useState } from 'react';

const faqs = [
  {
    q: '小草影院需要注册才能观看吗？',
    a: '完全不需要注册。小草影院所有电视剧均可直接在线观看，无需任何账号注册或登录。打开网页即点即看，方便快捷。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '小草影院采用多线CDN加速技术，确保流畅观影体验。如遇卡顿，建议切换网络环境或尝试降低播放清晰度，同时刷新页面即可恢复正常播放。',
  },
  {
    q: '支持哪些设备观看？',
    a: '小草影院支持电脑、平板、手机等多种设备。适配主流浏览器，横屏竖屏均可舒适观影，随时随地畅享高清剧集。',
  },
  {
    q: '剧集更新频率是怎样的？',
    a: '我们每日同步各大卫视及网络平台最新剧集，热播剧集通常当晚即可更新。追剧用户无需担心漏看任何一集，更新速度行业领先。',
  },
  {
    q: '如何反馈影片问题？',
    a: '如遇到影片无法播放、剧集缺失或画质问题，可通过联系投稿渠道发送邮件反馈。我们的内容团队会尽快处理并修复。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-question-answer-line"></i>
            常见问答
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于小草影院的常见疑问，这里都有解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <i
                  className={`text-lg text-foreground-400 transition-transform shrink-0 ${
                    openIndex === i ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}